<template lang="html">
    <div class="article">
        <div class="article__image">
            <img :src="imageUrl" alt="image" />
        </div>

        <div class="article__title">
            {{title}}
        </div>
        <div class="article__date">
            {{momentDate}} de {{author}}
        </div>
    </div>
</template>

<script>
    import * as moment from 'moment';

    export default {
        props: {
            title: {
                type: String,
                default: ''
            },
            imageUrl: {
                type: String,
                default: ''
            },
            date: {
                type: String,
                default: ''
            },
            author: {
                type: String,
                default: ''
            }
        },
        computed: {
            momentDate() {
                let dateString = this.date.slice(0, 4)+this.date.slice(5, 7)+this.date.slice(8, 10);
                return moment(dateString).format('LL');
            }
        }
    }
</script>

<style lang="scss" scoped>
    .article {
        cursor: pointer;
        margin-top: 25px;

        &:hover {
            img {
                transition: 0.3s ease;
                transform: scale(1.1);
            }

            .article__title {
                color: $color-primary;
            }
        }

        &__image {
            height: 192px;
            overflow: hidden;
            width: 100%;

            @include media-breakpoint-up(xl) {
                height: 95px;
            }

            img {
                height: 100%;
                object-fit: cover;
                transition: 0.3s ease;
                width: 100%;
            }

        }

        &__title {
            font-size: 16px;
            max-height: 48px;
            margin: 12px 0px 8px 0px;
            line-height: 24px;
            overflow: hidden;
        }

        &__date {
            color: #ADB5BD;
            font-size: 13.33px;
            font-weight: 300;
        }
    }
</style>